<script lang="ts" module>
	export const NUM_SWIMLANE_ITEMS = 20;

	// (Sometimes?) In swimlane, we want to display sold out items at the end.
	// Too complex for platform to implement
	export const putSoldOutItemsAtEnd = (products: ProductData[]) => {
		const productsInStock: ProductData[] = [];
		const productsOutOfStock: ProductData[] = [];
		products.forEach((product) => {
			if (product.in_stock) productsInStock.push(product);
			else productsOutOfStock.push(product);
		});
		
		return productsInStock.concat(productsOutOfStock);
	};
</script>
<script lang="ts">
	import type { ProductData, ProductTags } from "$lib/def/landing";
	import Product from "./Product.svelte";
	import type { Cache } from "$lib/serv/core/cache";
	import { slugify } from "$lib/util/format";
	import CarouselV3 from "$lib/ui/layout/CarouselV3.svelte";

	type Props = {
		cache: Cache<{ products: ProductData[] }>;
		title: string;
		gridViewUrl: string;
		hiddenTags?: ProductTags[];
	}

	let { cache, title, gridViewUrl, hiddenTags = [] }: Props = $props();

	let id = $derived.by(() => slugify(title));

</script>


<!-- TODO: @Dan - Add options -->
<CarouselV3 {cache} key={(payload) => payload?.products} uniqueKey={(item) => item?.catalogue_key} {id}>
	{#snippet title()}
		<h4 class="headline-m bold ellipses" data-testid={`${id}-title`}>{title}</h4>
		<a href={gridViewUrl} class="button transparent label-xl bold underlined" data-testid={`${id}-see-all`}>See all</a>
	{/snippet}
	{#snippet children({ item, index })}
		<Product {item} {hiddenTags} on:product/>
	{/snippet}
</CarouselV3>

<!-- TODO: @Dan - item is undefined after carousel v3, need to fix -->
<!-- <CarouselV2 {cache} type="aisle" key={(payload) => payload?.products} uniqueKey={(item) => item?.catalogue_key} {id}>
	{#snippet title()}
		<div class="flex mobile flex-nowrap title">
			<h4 class="headline-m bold ellipses" data-testid={`${id}-title`}>{title}</h4>
			<a href={gridViewUrl} class="button transparent label-xl bold underlined" data-testid={`${id}-see-all`}>See all</a>
		</div>
	{/snippet}
	{#snippet children({ item, index })}
		<Product {item} {hiddenTags} on:product/>
	{/snippet}
</CarouselV2> -->


<!-- <Carousel {cache} type="aisle" key={(payload) => payload?.products} uniqueKey={(item) => item.catalogue_key} let:item {id}>
	<div slot="title" class="flex mobile flex-nowrap title">
		<h4 class="headline-m bold ellipses" data-testid={`${id}-title`}>{title}</h4>
		<a href={gridViewUrl} class="button transparent label-xl bold underlined" data-testid={`${id}-see-all`}>See all</a>
	</div>
	<Product {item} {hiddenTags} on:product/>
</Carousel> -->
